import { api } from "./axiosInstance";

export type AppConfigResponse = {
  pollstar_enabled: boolean;
};

export const apiGetConfig = async (): Promise<AppConfigResponse> => {
  const response = await api.get("/api/v1/config");
  return response.data;
};
